<template>
  <!-- 进件页面 -->
  <div class="container" ref="container" v-cloak>
    <!-- 顶部借款金额 -->
    <div class="container-top">
      <div class="u-flex u-row-between">
        <div class="u-flex u-col-top">
          <div class="u-flex-col">
            <p class="container-top-title">借款订单已生成</p>
            <span class="container-top-span">首次借款需完成以下信息补充</span>
            <!-- 息费提示紧跟左侧申请说明，避免与右侧信息争抢视觉焦点。 -->
            <div class="entry-annual-rate-notice">
              <span>年化利率(单利)：7.2%~24%(已包含全部息费)</span>
              <span>具体年化以最终授信及签约前明示表为准</span>
            </div>
          </div>
        </div>
        <!-- <div class="u-flex-col u-text-right right">
          <p class="money">借款金额(元)</p>
          <h4 class="container-top-amount">{{ form.loanAmount }}</h4>
        </div> -->
      </div>
    </div>

    <!-- 注册表单 -->
    <div class="register-form">
      <!-- 个人信息 -->
      <div class="register-form-item register-form-item_inform">
        <!-- header -->
        <div class="register-form-item-header">
          <h4>完成实名认证</h4>
        </div>
        <div class="form-item-content">
          <!-- 真实姓名 -->
          <div class="mb0" ref="realName">
            <van-cell-group class="user_real_name">
              <van-field
                label="真实姓名"
                v-model.trim="form.realName"
                class="inp-elem"
                placeholder="请输入真实姓名"
                maxlength="20"
                @blur="handleBlur(0)"
                clearable
                input-align="right"
                :disabled="isEditIdCard"
              />
            </van-cell-group>
          </div>
          <!-- 身份证号 -->
          <div ref="idCard">
            <van-cell-group class="user_id_car">
              <van-field
                label="身份证号"
                v-model.trim="form.idCard"
                maxlength="18"
                class="inp-elem"
                placeholder="请输入身份证号"
                @blur="handleBlur(1)"
                clearable
                input-align="right"
                :disabled="isEditIdCard"
              />
            </van-cell-group>
          </div>
        </div>
      </div>
      <!-- 芝麻信 资产信息 -->
      <div class="register-form-item item_credit_creditType">
        <div class="register-form-item-header">
          <!-- 移除具体提升比例，仅保留原有填写提示。 -->
          <h4>完善基础信息</h4>
        </div>
        <div class="form-item-content">
          <!-- 芝麻信用分 -->
          <div class="credit" ref="credit">
            <div class="section-header" @click="toggleExpand('credit')">
              <h4>芝麻信用分</h4>

              <div class="header-right">
                <span>{{ form.credit }}</span>
                <van-icon
                  :name="expandStatus.credit ? 'arrow-up' : 'arrow-down'"
                  size="0.3rem"
                  color="#999"
                />
              </div>
            </div>
            <transition name="fade">
              <div v-show="expandStatus.credit" class="inp-elem tags">
                <van-row :gutter="5">
                  <van-col
                    v-for="(item, index) in formItemData.credit"
                    :key="index"
                    :class="item.active ? 'active' : ''"
                    :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
                    span="6"
                    @click="handleChooseCreditCredit(index, 'choose')"
                  >
                    <div class="u-flex u-col-center u-row-center credit-name">
                      {{ item.dictLabel }}
                      <p class="good-tips" v-if="item.isGood">优质</p>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </transition>
          </div>
          <!-- 资产信息(可多选) -->
          <div class="creditType">
            <div class="section-header" @click="toggleExpand('creditType')">
              <h4>资产信息(可多选)</h4>
              <div class="header-right">
                <span>
                  已选<span style="font-weight: bold; color: #fd6f34">{{ assetsLength }}</span
                  >项
                </span>
                <van-icon
                  :name="expandStatus.creditType ? 'arrow-up' : 'arrow-down'"
                  size="0.3rem"
                  color="#999"
                />
              </div>
            </div>
            <transition name="fade">
              <div v-show="expandStatus.creditType" class="inp-elem tags">
                <van-row :gutter="5">
                  <van-col
                    class="van-col-custom"
                    v-for="(item, index) in formItemData.creditType"
                    :key="index"
                    :class="item.active ? 'active' : ''"
                    span="8"
                    :style="(index + 1) % 3 == 0 ? 'margin-right:0' : ''"
                    @click="handleSelectCreditInfo(index, 'choose')"
                  >
                    <div class="u-flex-col u-col-center u-row-center credit-name">
                      <p>{{ item.dictLabel }}</p>
                      <div class="success-rate">
                        成功率
                        <img
                          v-if="item.active"
                          src="../../assets/images/entryThemeOne/icon-up-arrow-white.png"
                          alt=""
                        />
                        <img
                          v-else
                          src="../../assets/images/entryThemeOne/icon-up-arrow.png"
                          alt=""
                        />
                      </div>
                      <p class="good-tips" v-if="item.isGood">优质</p>
                    </div>
                  </van-col>
                </van-row>
                <!-- 车辆信息 -->
                <div class="car-box" ref="carBox" v-if="showCarInfoSection">
                  <h4>车辆信息</h4>
                  <div class="car-info">
                    <!-- 车牌号 -->
                    <div class="car-number">
                      <van-cell-group class="user_car_number">
                        <van-field
                          label="车牌号"
                          v-model.trim="form.plateNumber"
                          class="inp-elem car-number-line"
                          placeholder="请输入车牌号"
                          maxlength="20"
                          clearable
                          input-align="right"
                        />
                      </van-cell-group>
                    </div>
                    <!-- 车龄 -->
                    <div class="car-age">
                      <h4>车龄</h4>
                      <van-radio-group v-model="form.carAge" @change="handleCarAgeChange">
                        <van-row :gutter="16">
                          <van-col v-for="(item, index) in formItemData.carAge" :key="index">
                            <van-radio :name="item.dictValue" icon-size="16px" class="radio-item">
                              {{ item.dictLabel }}
                            </van-radio>
                          </van-col>
                        </van-row>
                      </van-radio-group>
                    </div>
                    <!-- 购车方式 -->
                    <div class="car-purchase">
                      <h4>购车方式</h4>
                      <van-radio-group
                        v-model="form.carPurchaseMethod"
                        @change="handleCarPurchaseChange"
                      >
                        <van-row :gutter="16">
                          <van-col
                            v-for="(item, index) in formItemData.carPurchaseMethod"
                            :key="index"
                          >
                            <van-radio :name="item.dictValue" icon-size="16px" class="radio-item">
                              {{ item.dictLabel }}
                            </van-radio>
                          </van-col>
                        </van-row>
                      </van-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <div class="career-box" ref="careerBox">
            <div class="section-header" @click="toggleExpand('career')">
              <h4>职业</h4>
              <div class="header-right">
                <span>{{ getCareer(form.occupation) || '' }}</span>
                <van-icon
                  :name="expandStatus.career ? 'arrow-up' : 'arrow-down'"
                  size="0.3rem"
                  color="#999"
                />
              </div>
            </div>
            <transition name="fade">
              <div v-show="expandStatus.career" class="inp-elem tags">
                <van-row :gutter="2">
                  <van-col
                    v-for="(item, index) in formItemData.career"
                    :key="index"
                    :class="item.active ? 'active' : ''"
                    :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
                    span="6"
                    @click="handleChooseCareer(index, 'choose')"
                  >
                    <div class="u-flex u-col-center u-row-center career-name">
                      {{ item.dictLabel }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </transition>
          </div>
          <!-- 逾期情况 -->
          <div class="creditInformation" ref="creditInformation">
            <div class="section-header" @click="toggleExpand('creditInformation')">
              <h4>逾期情况</h4>
              <div class="header-right">
                <span>{{ getCreditInformation(form.creditInformation) || '' }}</span>
                <van-icon
                  :name="expandStatus.creditInformation ? 'arrow-up' : 'arrow-down'"
                  size="0.3rem"
                  color="#999"
                />
              </div>
            </div>
            <transition name="fade">
              <div v-show="expandStatus.creditInformation" class="inp-elem tags">
                <van-row :gutter="5">
                  <van-col
                    v-for="(item, index) in formItemData.creditInformation"
                    :key="index"
                    :class="item.active ? 'active' : ''"
                    :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
                    span="5"
                    @click="handleChooseCreditInformation(index, 'choose')"
                  >
                    <div class="u-flex u-col-center u-row-center">
                      {{ item.dictLabel }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- 贷款申请城市 -->
      <div class="register-form-item select-city register-form-item_map">
        <van-cell-group>
          <van-field
            label="贷款申请城市"
            v-model="addressPositionName"
            readonly
            class="inp-elem"
            input-align="right"
            :border="false"
          >
            <template #input>
              <p @click="handleClickPosition">{{ addressPositionName }}</p>
            </template>
            <template #button>
              <div class="img_box">
                <img
                  @click="handleClickPosition"
                  src="../../assets/images/image_orange/entry/icon_position.png"
                  alt=""
                />
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <div class="map-tips">
          *准确的贷款申请城市将决定我们是否能为您提供贷款服务，请按您所在地如实填写
        </div>
      </div>
    </div>

    <!-- 合规提示即使暂未展示，也保持最新的费用、验证码及境外来电风险口径。 -->
    <!-- <div class="notice">
      <img
        class="notice-icon"
        src="../../assets/images/image_orange/entry/icon_tips.png"
        alt=""
      />
      本平台不会以任何名义向您收取费用，也不会要求您进行转账汇款、提供银行卡密码及短信验证码、缴纳保证金或验证资金等。本平台客服仅使用中国大陆地区电话号码，请勿接听来自中国港澳台地区，以及缅甸、美国等境外国家的陌生来电，谨防诈骗。
      <img
        class="notice-bg"
        src="../../assets/images/image_orange/entry/icon_tips_bg.png"
        alt=""
      />
    </div> -->
    <!-- 底部风险提示 -->
    <!-- <div class="bottom u-text-center">
      贷款有风险，借款需谨慎<br />
      综合年化7.2%-24%，最终结果以审批为准<br />
      请根据个人能力合理贷款，理性消费<br />
    </div> -->

    <div class="fixed-btn">
      <!-- 协议 -->
      <van-checkbox
        v-model="checked"
        @input="handleTl5ThemeOneAgreementChange"
        checked-color="#FD6F34"
        icon-size="0.3rem"
        class="protocols u-flex u-col-top"
      >
        我已阅读并同意
        <small @click.stop="showProp('xxsq')" class="protocols-title">
          《个人信息共享授权书》</small
        >
        <small @click.stop="showProp('zqgz')" class="protocols-title"> 《知情告知书》 </small>
      </van-checkbox>
      <!-- 确认额度 -->
      <div class="btn-con">
        <van-button
          class="btn"
          type="default"
          @click="handleSubmit"
          :loading="loading"
          loading-type="spinner"
        >
          确认额度
        </van-button>
        <!-- <small class="pa btn-tips">新用户立享30天免息券*2</small> -->
      </div>
    </div>

    <!-- 定位城市下拉选 -->
    <van-popup v-model="showPickerCity" position="bottom" safe-area-inset-bottom round>
      <van-picker
        show-toolbar
        :columns="areaList"
        @change="onCityChange"
        @confirm="onAreaConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      >
        <div slot="title" class="picker-title u-text-center">
          <p>请选择定位城市</p>
          <p class="pa">准确的贷款申请城市将决定我们是否能为您提供贷款服务，请按您所在地如实填写</p>
        </div>
      </van-picker>
    </van-popup>

    <Agreement
      @handleGoOn="handleGoOn"
      @popupOpened="handleTl5ThemeOneAgreementPopupOpened"
      @knowClicked="handleTl5ThemeOneAgreementKnowClicked"
      :incomingShow.sync="incomingShow"
      :sendData="sendData"
      :protocolDynamicData="protocolDynamicData"
      :form="form"
      :applyTime="applyTime"
      :companys="companys"
      :companyAlias="companyAlias"
      :productId="productId"
      :applyId="applyId"
    />
    <!-- 当前页面推贷超产品弹窗 -->
    <ProductsPop :productsPopShow="showProductsPop" :productsPopData="productsPopData" />
    <!-- 《个人信息共享授权书》和《知情告知书》局部弹窗 -->
    <van-popup
      v-model="showProtocol"
      round
      :style="{
        width: '80%',
        height: '70%',
      }"
      @close="handleClose"
    >
      <div class="show-protocol-con">
        <h4 class="u-text-center">{{ loaclTitle }}</h4>
        <div class="show-protocol-info protocol-content" v-html="showContent" />
        <div class="show-protocol-btn u-text-center" @click="showProtocol = false">关闭</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { setEncryption } from '@/utils/encrypt' //引入加密文件
import * as API_Common from '@/api/common.js'
import ProductsPop from '@/components/productsPop/index'
import Agreement from '@/components/Agreement'
import { entryCommon } from '@/mixins/entryCommon.js'
import { mapPosition } from '@/mixins/mapPosition.js'
import formPageBuriedMixin from '@/mixins/formPageBuriedMixin.js'

// import { getCookie, setCookie } from "@/utils/cookies.js";
import { setCookie } from '@/utils/cookies.js'
import { replaceTemplateValues } from '@/utils/replaceTemplateValues.js'
import { validateChinesePlateNumber, PLATE_NUMBER_FORMAT_ERROR_MSG } from '@/utils/plateNumber.js'
export default {
  name: 'RegisterEntryTl5',
  mixins: [entryCommon, mapPosition, formPageBuriedMixin],
  data() {
    return {
      positionStatus: false, // 定位是否成功，默认false
      positionCityStatus: false, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)
      provinceArr: undefined, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)-集合中是对应省的一条数据
      checked: false, // 协议勾选
      address: {
        // 定位地址
        province: '', // 省
        city: '', // 市
      },
      areaList: [
        // 自定义省数据二级结构
        { values: [] },
        { values: [] },
      ],
      showPickerCity: false, // 省市联动弹窗状态
      form: {
        // 提交表单
        channelNo: this.$route.query.source, // 渠道标识
        loanAmount: this.$route.query.amount || 100000, // 借款金额
        loanPurpose: this.$route.query.purpose, // 借款用途
        loanPeriod: this.$route.query.period
          ? parseInt(this.$route.query.period) === 9
            ? 12
            : this.$route.query.period
          : 6, // 借款期限(宜享花传入的期限可能为9期，为了兼容咱们自己的借款期限(目前支持3 6 12 24)的情况如果宜享花传入的期数为9强制修改为12期 )
        realName: '', // 姓名
        idCard: '', // 身份证号码
        credit: '', // 芝麻分
        occupation: '', // 职业
        assets: [], // 个人资产
        gpsCityName: '', // 省市展示名称
        cityId: '', // 城市ID
        provinceId: '', // 省ID
        creditInformation: '', // 逾期情况
        isCar: 0,
        showCarInfo: 1,
        plateNumber: '', // 车牌号
        carAge: '', // 车龄
        carPurchaseMethod: '', // 购车方式
      },
      formItemData: {
        credit: [
          // 芝麻分集合
          {
            dictValue: '700以上',
            dictLabel: '700以上',
            isGood: true,
            active: false,
          },
          {
            dictValue: '650-700',
            dictLabel: '650-700',
            isGood: true,
            active: false,
          },
          { dictValue: '600-650', dictLabel: '600-650', active: false },
          { dictValue: '600以下', dictLabel: '600以下', active: false },
        ],
        career: [
          // 职业集合
          { dictValue: 1, dictLabel: '上班族' },
          { dictValue: 2, dictLabel: '自由职业' },
          { dictValue: 3, dictLabel: '私营企业主' },
          { dictValue: 4, dictLabel: '公务员/国企' },
        ],
        creditType: [
          // 个人资产集合（须带 active，Vue2 勾选「有车」联动展示）
          { dictValue: 3, dictLabel: '有公积金', isGood: true, active: false },
          { dictValue: 1, dictLabel: '有房', isGood: true, active: false },
          { dictValue: 2, dictLabel: '有车', isGood: true, active: false },
          { dictValue: 4, dictLabel: '有社保', isGood: true, active: false },
          {
            dictValue: 5,
            dictLabel: '有商业保险',
            isGood: true,
            active: false,
          },
          { dictValue: 6, dictLabel: '企业主', isGood: true, active: false },
        ],
        creditInformation: [
          // 逾期情况
          { dictValue: 1, dictLabel: '征信良好' },
          { dictValue: 2, dictLabel: '无人行征信' },
          { dictValue: 3, dictLabel: '有逾期' },
        ],
        carAge: [
          // 车龄集合
          { dictValue: 1, dictLabel: '0-5年' },
          { dictValue: 2, dictLabel: '5-10年' },
          { dictValue: 3, dictLabel: '10年以上' },
        ],
        carPurchaseMethod: [
          // 购车方式集合
          { dictValue: 1, dictLabel: '全款' },
          { dictValue: 2, dictLabel: '分期-已结清' },
          { dictValue: 3, dictLabel: '分期-未结清' },
        ],
      },
      regTest: {
        // 正则校验
        regIdcard:
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, // 身份证号码正则校验
        regName: /^[\u4e00-\u9fa5]{2,10}[·.]*$/, // 姓名2-10位中文正则校验
      },
      xxsq: '', // 个人信息共享授权书
      // xxsqHeightFlag: true, // 个人信息共享授权书局部内容是否展开状态
      zqgz: '', // 知情告知书
      // zqgzHeightFlag: true, // 知情告知书局部内容是否展开状态
      showContent: '', //  // 个人信息共享授权书 和 知情告知书 局部弹窗详细内容
      showProtocol: false, // 个人信息共享授权书 和 知情告知书 局部弹窗隐藏显示
      // tdgrxx: "", //特定机构个人信息授权
      // tdgrxxHeightFlag: true, //特定机构个人信息授权是否展开状态
      // tdyszc: "", //特定机构知情告知书
      // tdyszcHeightFlag: true, // 特定机构知情告知书是否展开状态
      tdArea: '', // 特定机构的地理位置信息
      isSpecificInstitution: false, //是否需要展示特定机构的协议
      companys: '', // 公司名称集合
      companyAlias: '', // 公司别名
      loaclTitle: '', // 局部协议弹窗顶部title,
      brand: this.$route.query.brand, // 设备型号
      downPageUrl: this.$route.query.downPageUrl, // 进件结果下载页地址
      applyId: '', // 进件申请ID
      applyTime: '', // 进件申请时间
      assetsLength: 0, // 个人资产数量
      hasPushSuccess: undefined, // 是否推送成功
      loanSuperPageRedirectRule: undefined, // 贷超页面跳转规则
      jwt: this.$route.query.jwt, // 登录字符串
      env: process.env.NODE_ENV, // 是否是线上环境
      loading: false, //确认额度按钮点击状态
      isRedirectProductsPage: parseInt(this.$route.query.isRedirectProductsPage), // 标识是否是贷超流程的字段1是 0否
      isRedirectWorkWeixinPage: parseInt(this.$route.query.isRedirectWorkWeixinPage), // 标识如果不是贷超流程需要用此字段进行判断是否跳转引导企业微信页面中，引导用户用企业微信扫码联系客服1是 0否
      workWeixinUrl: this.$route.query.workWeixinUrl, // 跳转微信地址url
      isTail: undefined, // 是否是兜底 1-是 0-否
      redirectUrl: '', // 重定向链接
      productId: null, // 产品id
      sendData: null,
      apiReqType: null, //接口请求类型, 1-闪借花、2-吉琼宝
      jqbApplyId: null, //吉琼包申请ID
      jqbProductId: null, //jqbProductId
      isShowTenAccount: this.$route.query.isShowTenAccount,
      isEditIdCard: false, // 是否可以编辑身份证号和姓名
      isShowNewTips: false, // 根据渠道判断是否不展示中国香港
      protocolDynamicData: {
        // 协议动态值
        idCard: '',
        realName: '',
        mobile: '',
        uid: '',
      },
      showProductsPop: false, // 当前页面推产品展示弹窗
      productsPopData: [], // 当前页面推产品展示弹窗数据
      // 展开状态
      expandStatus: {
        credit: true,
        creditType: true,
        creditInformation: true,
        career: true,
      },
    }
  },
  components: {
    ProductsPop,
    Agreement,
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'registerEntryTl5ThemeOne'
  },
  mounted() {
    // this.checkPosition(); // 获取是否支持定位
    this.getUserDetail() // 用户回显信息
    this.getProtocol() // 获取个人信息共享授权书 和 知情告知书 协议内容
    this.getCityLocation()
    this.isShowTenAccount = this.$route.query.isShowTenAccount
    console.log('this.$route.query', this.$route.query)
    // vuex中存储登录状态
    this.$nextTick(() => {
      this.$store.dispatch('setJwt', this.jwt)
    })
    setCookie('token', this.jwt) // 直接拿jwt替换本地token-20250416修改逻辑
    // let cookies = getCookie("token");
    // if (!cookies || cookies === "") {
    //   setCookie("token", this.jwt);
    // }
    // if (
    //   this.$route.query.linkFromPage &&
    //   this.$route.query.linkFromPage === "wechat_miniprogram"
    // ) {
    //   setCookie("token", this.jwt);
    // }

    // 根据不同渠道展示不同文案
    if (
      this.$route.query.source == 'tongcheng01' ||
      this.$route.query.source == 'wwwooo22' ||
      this.$route.query.source == 'wwwooo03' ||
      this.$route.query.source == 'wwwooo04'
    ) {
      this.isShowNewTips = true
    }

    // 新增根据source判断title是否展示湘江源小贷
    if (this.$route.query.source == 'ceshi003') {
      document.title = '湘江源小贷'
    }
  },

  computed: {
    hasSelectedCar() {
      const car = this.formItemData.creditType.find((i) => i.dictValue === 2)
      return !!(car && car.active)
    },
    showCarInfoFromApi() {
      const v = this.form.showCarInfo
      if (v === true || v === '1') return true
      const n = Number(v)
      return n === 1 && !Number.isNaN(n)
    },
    showCarInfoSection() {
      return this.showCarInfoFromApi && this.hasSelectedCar
    },
    addressPositionName() {
      // 顶部定位名称
      if (this.positionStatus) {
        return `${this.address.province} ${this.address.city}`
      } else {
        if (this.form.gpsCityName) {
          return this.form.gpsCityName
        } else {
          return ''
        }
      }
    },
  },
  methods: {
    // 职业名称
    getCareer(id) {
      return this.formItemData.career.find((item) => item.dictValue == id)?.dictLabel || ''
    },
    // 逾期情况
    getCreditInformation(id) {
      return (
        this.formItemData.creditInformation.find((item) => item.dictValue == id)?.dictLabel || ''
      )
    },
    // 切换展开/收起状态
    toggleExpand(key) {
      this.expandStatus[key] = !this.expandStatus[key]
    },
    //20251218日需求修改，用用户ip去判断地区，给地区赋值，赋值错误的话用户可以自己填写
    // 获取IP定位信息
    getCityLocation() {
      API_Common.getCityLocation()
        .then((res) => {
          if (res.code == 200) {
            const data = res.data
            // 只有当不是"全国"时才认为是有效的定位信息
            if (
              data.provinceName &&
              data.cityName &&
              data.provinceName !== '全国' &&
              data.cityName !== '全国'
            ) {
              // 使用后台返回的地区信息
              this.address.province = data.provinceName
              this.address.city = data.cityName
              this.form.gpsCityName = `${data.provinceName} ${data.cityName}`
              this.positionStatus = true

              // 如果有地区ID也赋值
              if (data.provinceId) {
                this.form.provinceId = data.provinceId
              }
              if (data.cityId) {
                this.form.cityId = data.cityId
              }

              console.log('IP定位成功:', this.form.gpsCityName)
            } else {
              console.log('IP定位失败或定位为全国，需要用户手动选择')
              // 定位失败时设置提示信息
              this.positionStatus = false
              this.form.gpsCityName = '定位失败，请手动选择'
              // 清空相关定位数据
              this.address.province = ''
              this.address.city = ''
              this.form.cityId = ''
              this.form.provinceId = ''
            }
          } else {
            // API返回错误码时
            console.log('IP定位API返回错误:', res.msg)
            this.positionStatus = false
            this.form.gpsCityName = '定位失败，请手动选择'
            // 清空相关定位数据
            this.address.province = ''
            this.address.city = ''
            this.form.cityId = ''
            this.form.provinceId = ''
          }
        })
        .catch((error) => {
          console.error('获取IP定位失败:', error)
          this.positionStatus = false
          this.form.gpsCityName = '定位失败，请手动选择'
          // 清空相关定位数据
          this.address.province = ''
          this.address.city = ''
          this.form.cityId = ''
          this.form.provinceId = ''
        })
    },
    validateText(text) {
      // 1. 检查是否只包含中文、中文点(·)和英文点(.)
      if (!/^[\u4e00-\u9fa5·.]+$/.test(text)) {
        this.$toast('请输入正确的姓名')
        return false
      }

      // 2. 移除所有点，统计纯中文字符数量
      const chineseOnly = text.replace(/[·.]/g, '')
      const chineseCount = chineseOnly.length

      // 3. 验证中文数量在2-10之间
      if (chineseCount < 2 || chineseCount > 10) {
        this.$toast('姓名必须2-10个汉字')
        return false
      } else {
        return true
      }
    },
    // 监听表单blur
    handleBlur(index) {
      switch (index) {
        case 0: // 姓名输入框失去光标
          this.validateText(this.form.realName)
          this.protocolDynamicData.realName = this.form.realName
          break
        case 1: // 身份证输入框失去光标
          if (this.form.idCard !== '') {
            if (!this.regTest.regIdcard.test(this.form.idCard)) {
              this.$toast('请输入正确的身份证号码')
            } else {
              this.protocolDynamicData.idCard = this.form.idCard
            }
          }
          break
      }
    },

    // 表单提交
    async handleSubmit() {
      this.handleSubmitTrack()
      console.log(this.form, this.positionStatus)
      if (this.form.realName === '') {
        this.$toast('请输入姓名')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (!this.validateText(this.form.realName)) {
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (this.form.idCard === '') {
        this.$toast('请输入身份证号码')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast('请输入正确的身份证号码')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (this.form.credit === '') {
        this.$toast('请选择芝麻分')
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (!this.form.occupation || this.form.occupation === '') {
        // 职业
        this.$toast('请选择您的职业')
        this.$refs.container.scrollTo({
          top: this.$refs.careerBox.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (!this.form.creditInformation || this.form.creditInformation === '') {
        // 逾期情况
        this.$toast('请选择逾期情况')
        this.$refs.container.scrollTo({
          top: this.$refs.creditInformation.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (this.showCarInfoSection) {
        if (!this.form.plateNumber || this.form.plateNumber === '') {
          this.$toast('请输入车牌号')
          this.$refs.container.scrollTo({
            top: this.$refs.carBox.offsetTop,
            behavior: 'smooth',
          })
          return
        }
        if (!validateChinesePlateNumber(this.form.plateNumber)) {
          this.$toast(PLATE_NUMBER_FORMAT_ERROR_MSG)
          this.$refs.container.scrollTo({
            top: this.$refs.carBox.offsetTop,
            behavior: 'smooth',
          })
          return
        }
        if (!this.form.carAge || this.form.carAge === '') {
          this.$toast('请选择车龄')
          this.$refs.container.scrollTo({
            top: this.$refs.carBox.offsetTop,
            behavior: 'smooth',
          })
          return
        }
        if (!this.form.carPurchaseMethod || this.form.carPurchaseMethod === '') {
          this.$toast('请选择购车方式')
          this.$refs.container.scrollTo({
            top: this.$refs.carBox.offsetTop,
            behavior: 'smooth',
          })
          return
        }
      }
      this.form.assets = []
      this.formItemData.creditType.map((i) => {
        if (i.active) {
          this.form.assets.push(i.dictValue)
        }
      })

      if (this.form.assets.length === 0) {
        this.$toast('请至少选择一项资产')
        return
      }

      if (!this.positionStatus && this.form.cityId === '') {
        this.$toast('请选择您所在的城市')
        return
      } else if (!this.checked) {
        this.$toast('请勾选同意授权及告知书')
        return
      }

      // 按钮loading
      this.loading = true

      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      }
      console.log(datas, 'daaaass')
      //华为荣耀添加的字段
      if (this.$route.query.trackId) {
        datas.trackId = this.$route.query.trackId
      }
      let logData = {
        applyId: null,
        errorType: null,
        applySource: 2,
        errorMsg: null,
      }
      try {
        //小程序webview内打开页面
        if (this.isMini) {
          datas.source = 'miniProgram'
        }
        let res = await API_Common.submitAnEntry(datas)
        this.isTail = res?.data && res.data.isTail ? res.data.isTail : undefined // 获取此次进件流程是否为兜底
        //埋点数据的值
        logData.errorType = 1
        logData.applyId = res?.data?.applyId
        logData.errorMsg = res?.msg
        if (res?.code === 200) {
          // 取消按钮loading
          this.loading = false

          // 进件申请ID赋值(applyId如果为0则代表进件失败，否则代表成功
          // 1: 贷超流程，失败了要跳转贷超页面
          // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
          //进件ID
          if (res.data) {
            this.applyId = res.data.applyId
            // 产品ID
            this.productId = res.data.productId
            // 是否推送成功;
            // 1: 贷超流程，失败了要跳转贷超页面
            // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
            this.sendData = res.data //发送给协议弹窗页面
            this.hasPushSuccess = res.data.hasPushSuccess
            this.loanSuperPageRedirectRule = res.data.loanSuperPageRedirectRule // 贷超跳转规则
            this.isRedirectProductsPage = res.data.isRedirectProductsPage // 是否跳转贷超列表页
            // this.qiWeiUrl = res.data.qiWeiUrl; //是否跳转企微
            this.applyTime = res.data.applyTime
            // 重定向页面地址
            this.redirectUrl = res.data.redirectUrl
            //吉琼宝参数
            this.jqbApplyId = res.data.jqbApplyId
            this.jqbProductId = res.data.jqbProductId
            this.apiReqType = res.data.apiReqType
          }

          await this.afterSubmitAnEntrySuccess(res)
        } else if (res?.code === 1109 || res?.code === 1110) {
          // 取消按钮loading
          this.loading = false
          //添加埋点
          API_Common.addMatchStayLog(logData)
          // 区分贷超流程以及非贷超流程
          // 1109:进件的时候手机号是同一个身份证是同一个重复提交-跳转红包下载页面
          // 1110: 此处判断为进件重复(规则是进件的时候身份证是一个但是手机号不同的情况-跳转红包下载页面)
          this.$toast(res.msg)
          //需要跳转的页面
          this.gotoNextPage(false)
        } else {
          //添加埋点
          API_Common.addMatchStayLog(logData)
          this.loading = false
          if (res?.msg) {
            this.$toast(res.msg)
          }
        }
      } catch (error) {
        this.requestErrorHandle(error, logData)
      }
    },
    // 选择芝麻分
    handleChooseCreditCredit(index) {
      this.formItemData.credit.map((item) => {
        item.active = false
      })
      this.formItemData.credit[index].active = true
      this.form.credit = this.formItemData.credit[index].dictValue
      this.$forceUpdate()
      this.$refs.container.scrollTo({
        top: this.$refs.credit.offsetTop,
        behavior: 'smooth',
      })
      // 选择后自动收起
      this.expandStatus.credit = false
    },

    // 选择信用信息（多选）
    handleSelectCreditInfo(index) {
      const row = this.formItemData.creditType[index]
      if (row.active) {
        let arr = this.formItemData.creditType.filter((item) => item.active)

        if (arr.length > 1) {
          this.$set(row, 'active', false)
        } else {
          this.$toast.fail('至少保留一项')
        }
      } else {
        this.$set(row, 'active', true)
      }
      this.$forceUpdate()
      this.assetsLength = this.formItemData.creditType.filter((item) => item.active).length

      const carItem = this.formItemData.creditType.find((i) => i.dictValue === 2)
      this.form.isCar = carItem && carItem.active ? 1 : 0
    },
    // 选择职业
    handleChooseCareer(index) {
      this.formItemData.career.map((item) => {
        item.active = false
      })
      this.formItemData.career[index].active = true
      this.form.occupation = this.formItemData.career[index].dictValue
      this.$forceUpdate()
      // 选择后自动收起
      this.expandStatus.career = false
    },
    // 选择逾期情况
    handleChooseCreditInformation(index) {
      this.formItemData.creditInformation.map((item) => {
        item.active = false
      })
      this.formItemData.creditInformation[index].active = true
      this.form.creditInformation = this.formItemData.creditInformation[index].dictValue
      this.$forceUpdate()
      this.$refs.container.scrollTo({
        top: this.$refs.creditInformation.offsetTop,
        behavior: 'smooth',
      })
      // 选择后自动收起
      this.expandStatus.creditInformation = false
    },
    // 车龄变更
    handleCarAgeChange() {},
    // 购车方式变更
    handleCarPurchaseChange() {},
    // 显示协议
    showProp(type) {
      if (type == 'xxsq') {
        let replacements = {
          idCard: this.protocolDynamicData.idCard,
          username: this.protocolDynamicData.realName,
          phone: this.protocolDynamicData.mobile,
          uid: this.protocolDynamicData.uid,
        }
        // 替换协议html中的动态参数
        let xxsqProtocol = replaceTemplateValues(this[type], replacements)
        this.showContent = xxsqProtocol
      } else {
        this.showContent = this[type]
      }
      this.showProtocol = true
      this.loaclTitle = type === 'zqgz' ? '《知情告知书》' : '《个人信息共享授权书》'
    },

    // 弹窗关闭时触发
    handleClose() {
      this.showContent = ''
      this.loaclTitle = ''
    },

    // 获取个人信息共享授权书 和 知情告知书 协议内容
    getProtocol() {
      Promise.all([
        API_Common.getContent({
          pageType: 13,
          source: this.form.channelNo,
        }),
        API_Common.getContent({
          pageType: 14,
          source: this.form.channelNo,
        }),
      ]).then((res) => {
        this.xxsq = res[0].data.content
        this.zqgz = res[1].data.content
      })
    },
    //用户资产回显
    getUserDetail() {
      var channelCode = this.$route.query.source
      this.getUserDetailOldWithTrack(channelCode)
        .then((res) => {
          if (res.code == 200) {
            const data = res.data
            if (data) {
              if (data.idCardAuth == 5) {
                this.isEditIdCard = true
              }
              localStorage.setItem('userId', data.userId)

              // 协议动态值
              this.protocolDynamicData.idCard = data.idCard ? data.idCard : ''
              this.protocolDynamicData.realName = data.userName ? data.userName : ''
              this.protocolDynamicData.mobile = data.mobile ? data.mobile : ''
              this.protocolDynamicData.uid = data.userId ? data.userId : ''
              // 表单赋值
              this.form.realName = data.userName
              this.form.idCard = data.idCard
              this.form.creditInformation = data.creditInformation
              this.form.showCarInfo =
                data.showCarInfo !== undefined && data.showCarInfo !== null
                  ? Number(data.showCarInfo)
                  : 1
              if (data.isCar !== undefined && data.isCar !== null) {
                this.form.isCar = Number(data.isCar)
              }
              if (data.plateNumber) {
                this.form.plateNumber = data.plateNumber
              }
              if (data.carAge !== undefined && data.carAge !== null && data.carAge !== '') {
                this.form.carAge = data.carAge
              }
              if (
                data.carPurchaseMethod !== undefined &&
                data.carPurchaseMethod !== null &&
                data.carPurchaseMethod !== ''
              ) {
                this.form.carPurchaseMethod = data.carPurchaseMethod
              }
              console.log('this.form.creditInformation', this.$route.query.amount)
              if (data.loanAmount && !this.$route.query.amount) {
                // 借款金额展示规则；先取url里边amount值，没有则取details接口返回值值，都没有取一个默认值
                this.form.loanAmount = data.loanAmount
              }
              this.formItemData.credit.forEach((item, index) => {
                if (item.dictValue === data.sesameCreditScore) {
                  this.handleChooseCreditCredit(index, 'default')
                }
              })
              // 职业回写
              this.form.occupation = data.occupation ? data.occupation : ''
              this.formItemData.career.forEach((item, index) => {
                if (data.occupation && item.dictValue === data.occupation) {
                  this.handleChooseCareer(index, 'default')
                }
              })
              this.formItemData.creditInformation.forEach((item, index) => {
                if (item.dictValue === data.creditInformation) {
                  this.handleChooseCreditInformation(index, 'default')
                }
              })
              this.formItemData.creditType.forEach((item, index) => {
                switch (item.dictValue) {
                  case 1:
                    if (data.room) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                  case 2:
                    if (data.vehicle) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                  case 3:
                    if (data.providentFund) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                  case 4:
                    if (data.socialSecurity) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                  case 5:
                    if (data.businessInsurance) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                  case 6:
                    if (data.businessOwners) {
                      this.handleSelectCreditInfo(index, 'default')
                    }
                    break
                }
              })
            }
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 2.76rem;
  background: url('../../assets/images/image_orange/entry/top_bg.png') no-repeat;
  background-size: 100% 2.26rem;
  min-height: 100vh;
  background-color: #f5f5f5;

  /* 头部标题带箭头样式 */
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2rem;
    cursor: pointer;

    h4 {
      margin: 0;
      font-size: 0.32rem;
      font-weight: 600;
      color: #333;
    }
    .header-right {
      display: flex;
      align-items: center;
      gap: 0.14rem;
      font-size: 0.24rem;
      color: rgb(153, 153, 153);

      .van-icon {
        transition: transform 0.3s ease;
        transform-origin: center;
      }

      .van-icon-arrow-up {
        transform: rotate(0deg);
      }

      .van-icon-arrow-down {
        transform: rotate(180deg);
      }
    }
  }

  /* 过渡动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease-out;
    will-change: transform, opacity;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .inp-elem.tags {
    overflow: hidden;
  }

  .fixed-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    text-align: center;
    padding: 0.4rem 0;
  }

  .notice {
    position: relative;
    padding: 0.16rem 0.2rem;
    font-size: 0.2rem;
    color: #98847d;
    background: #ffffff;
    border-radius: 0.2rem;
    border: 1px solid #ffede6;
    margin: 0 0.32rem 0.2rem;
    text-indent: 1.2em;

    .notice-icon {
      position: absolute;
      width: 0.2rem;
      height: 0.2rem;
      left: 0.2rem;
      top: 0.2rem;
    }

    .notice-bg {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 1.28rem;
    }
  }

  .container-top {
    padding: 0.38rem 0.38rem 0.15rem 0.35rem;

    width: 100%;
    // height: 2.26rem;

    > div {
      font-size: 0.24rem;
      border-radius: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #868e9e;

      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.16rem;
      }

      .container-top-title {
        font-family: PingFangSC, PingFangSC-Medium;
        margin-bottom: 0.12rem;
        font-weight: 600;
        font-size: 0.4rem;
        color: #461401;
        line-height: 0.48rem;
      }

      .container-top-span {
        color: #aa664a;
        font-size: 0.24rem;
      }

      .money {
        color: #aa664a;
        font-size: 0.2rem;
        margin-bottom: 0.06rem;
      }

      .container-top-amount {
        font-size: 0.44rem;
        font-family: Helvetica, Helvetica-Helvetica;
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .register-form {
    border-radius: 0.3rem;
    padding: 0.2rem 0.32rem 0.2rem;
    background-color: transparent;
  }

  .register-form-item {
    margin-top: 0.3rem;
    margin-bottom: 0.21rem;
    // padding: 0.4rem 0.32rem;
    border-radius: 0.26rem;
    &.select-city {
      padding: 0.4rem 0.32rem;
      background-color: #fff;
    }

    .register-form-item-header {
      font-size: 0.3rem;
      width: 100%;
      border-radius: 0.26rem 0.26rem 0 0;
      background: linear-gradient(90deg, #ffe9db 0%, #faece8 66.83%, rgba(250, 238, 234, 0) 100%);
      padding: 0.4rem 0.1rem 0.66rem;
      z-index: 1;
      h4 {
        margin-left: 0.16rem;
        font-weight: 600;
        font-size: 0.25rem;
        line-height: 0.25rem;
        color: #953300;
        text-align: left;
        text-indent: 0.1rem;
        border-left: 0.08rem solid #fd6f34;
      }
    }
    .form-item-content {
      margin-top: -0.26rem;
      padding: 0.4rem 0.32rem;
      background-color: #fff;
      border-radius: 0.26rem;
    }
    &.mb0 {
      margin-bottom: 0;
    }

    .inp-elem {
      padding: 0;
      justify-content: center;
      align-items: center;
    }

    &.car-number-line {
      padding: 0.21rem 0;
      border-bottom: 1px solid #ededed;
    }

    > h4 {
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #111c31;
    }

    ::v-deep {
      .van-field__label {
        font-size: 0.28rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 500;
        color: #333333;
      }

      .van-field__control {
        color: #868e9e;
        font-size: 0.28rem;
        caret-color: #111c31;
      }
    }

    small {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #868e9e;
      display: block;
      padding-bottom: 0.1rem;
    }
  }

  //用户信息
  .register-form-item_inform {
    .inp-elem {
      line-height: 0;
    }

    .user_real_name {
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #f0f0f0;

      ::v-deep {
        .van-field__label {
          line-height: 0.4rem;
        }
      }
    }

    .user_id_car {
      padding-top: 0.28rem;

      ::v-deep {
        .van-field__label {
          line-height: 0.4rem;
        }
      }
    }
  }

  // 芝麻分  资产信息
  .item_credit_creditType {
    // padding-bottom: 0.45rem;

    h4 {
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 500;
      color: #333333;
      margin-bottom: 0.02rem;
    }

    .credit {
      margin-bottom: 0.34rem;
      padding-bottom: 0.34rem;
      border-bottom: 1px solid #f7f7f8;

      .tags {
        .van-col {
          padding: 0 !important;
          margin-right: 0.18rem;
          width: 1.38rem;
          // width: 1.96rem;
        }

        .van-col > div {
          height: 0.66rem;
          margin-top: 0;
          border: none;
          background: #f7f7f7;
          border-radius: 0.1rem;
          margin-top: 0.26rem;
        }

        .active > div {
          background: #fd6f34;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }

    .car-box {
      margin-bottom: 0.4rem;
      border-bottom: 1px solid #f7f7f8;

      > h4 {
        margin-top: 0.3rem;
        margin-bottom: 0.28rem;
        letter-spacing: 0.01em;
      }

      .car-info {
        padding-top: 0.04rem;
      }

      .car-number {
        margin-bottom: 0.4rem;

        ::v-deep .user_car_number.van-hairline--top-bottom::after {
          border-width: 0;
        }

        ::v-deep .van-cell {
          padding-top: 0.3rem;
          padding-bottom: 0.3rem;
          align-items: center;
        }
      }

      .car-age {
        margin-bottom: 0.28rem;

        h4 {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-bottom: 0.2rem;
          line-height: 1.4;
        }

        .radio-item {
          width: 100%;
          display: flex;
          align-items: flex-start;
          min-height: 0.72rem;
        }

        ::v-deep {
          .van-radio-group {
            display: block;
          }

          .van-radio {
            display: flex;
            align-items: flex-start;
            padding: 0.06rem 0;
          }

          .van-radio__label {
            font-size: 0.28rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #3b3b3b;
            margin-left: 0.14rem;
            line-height: 1.45;
            white-space: normal;
            word-break: break-all;
          }

          .van-radio__icon {
            margin-top: 0.04rem;
          }

          .van-radio__icon--checked .van-icon {
            border-color: #fd6f34;
            background-color: #fd6f34;
          }
        }
      }

      .car-purchase {
        padding-bottom: 0.08rem;

        h4 {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
        }

        .radio-item {
          width: 100%;
          display: flex;
          align-items: flex-start;
          min-height: 0.72rem;
          color: #333333;
          margin-bottom: 0.2rem;
          margin-top: 0;
          line-height: 1.4;
        }

        ::v-deep {
          .van-radio-group {
            display: block;
          }

          .van-radio {
            display: flex;
            align-items: flex-start;
            padding: 0.06rem 0;
          }

          .van-radio__label {
            font-size: 0.28rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #3b3b3b;
            margin-left: 0.14rem;
            line-height: 1.45;
            white-space: normal;
            word-break: break-all;
          }

          .van-radio__icon {
            margin-top: 0.04rem;
          }

          .van-radio__icon--checked .van-icon {
            border-color: #fd6f34;
            background-color: #fd6f34;
          }
        }
      }
    }

    .creditType {
      margin-bottom: 0.34rem;
      padding-bottom: 0.34rem;
      border-bottom: 1px solid #f7f7f8;
      .tags {
        .van-col-custom {
          padding: 0 !important;
          margin-right: 0.24rem;
          width: 1.86rem;
        }

        .van-col-custom > div {
          border: none;
          background: #f7f7f7;
          border-radius: 0.1rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.28rem;
          color: #3b3b3b;
          line-height: 0.4rem;
          margin-top: 0.24rem;
          padding: 0.1rem 0;

          .success-rate {
            font-size: 0.24rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #ff7228;
            img {
              width: 0.24rem;
              height: 0.24rem;
              vertical-align: middle;
            }
          }
        }

        .active > div {
          background: #fd6f34;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          .success-rate {
            color: #ffffff;
          }
        }
      }
    }
    .career-box {
      .tags {
        .van-col {
          padding: 0 !important;
          margin-right: 0.24rem;
          width: 1.76rem;
        }

        .van-col > div {
          border: none;
          background: #f7f7f7;
          border-radius: 0.1rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.28rem;
          color: #3b3b3b;
          line-height: 0.4rem;
          margin-top: 0.24rem;
          padding: 0.1rem 0;

          .success-rate {
            font-size: 0.24rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #ff7228;
            img {
              width: 0.24rem;
              height: 0.24rem;
              vertical-align: middle;
            }
          }
        }

        .active > div {
          background: #fd6f34;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          .success-rate {
            color: #ffffff;
          }
        }
      }
    }
    .creditInformation {
      margin-top: 0.34rem;
      padding-top: 0.34rem;
      border-top: 1px solid #f7f7f8;

      .tags {
        .van-col {
          padding: 0 !important;
          margin-right: 0.24rem;
          width: 1.86rem;

          &:last-child {
            margin-right: 0;
          }
        }

        .van-col > div {
          height: 0.68rem;
          border: none;
          background: #f7f7f7;
          border-radius: 0.1rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.28rem;
          color: #3b3b3b;
          line-height: 0.4rem;
          margin-top: 0.24rem;
        }

        .active > div {
          background: #fd6f34;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .credit-name {
    position: relative;
  }
  .good-tips {
    position: absolute;
    top: -0.2rem;
    right: 0;
    font-size: 0.16rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0.04rem 0.08rem;
    line-height: 0.2rem;
    border-radius: 0.3rem 0.3rem 0.3rem 0;
    background: #ff7228;
  }
  //地理定位
  .register-form-item_map {
    margin-bottom: 0;

    .map-tips {
      margin-top: 0.34rem;
      background: #fcfcfc;
      border-radius: 0.16rem;
      border: 1px solid #f0f1f4;
      font-weight: 400;
      font-size: 10px;
      color: #989aa7;
      padding: 0.16rem 0.2rem;
    }

    .inp-elem {
      padding: 0;
    }

    ::v-deep {
      .van-cell {
        line-height: 0.4rem;
      }

      .van-field__control {
        color: #fd6f34;
      }

      .van-field__button img {
        width: 0.28rem;
        height: 0.28rem;
        vertical-align: middle;
      }
    }
  }

  //地址介绍
  .citys-tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.22rem;
    color: #a5a5a5;
    line-height: 0.3rem;
  }

  .border-none {
    border: none;
  }

  .van-hairline--top-bottom::after {
    display: none;
  }

  .tags {
    font-size: 0.28rem;
    color: #868e9e;
  }

  //提交按钮
  .btn-con {
    padding: 0 0.58rem;
    bottom: 0;
  }

  .btn {
    width: 100%;
    background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
    box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
    border-radius: 0.54rem;
    border: 0;
    font-family: PingFangSC, PingFangSC-Medium;
    font-size: 0.32rem;
    font-weight: 500;
    color: #fff;
    height: 1.08rem;
    line-height: 1.08rem;
    vertical-align: bottom;
    margin: 0.19rem 0 0.28rem;
    box-shadow: 0rem 0.06rem 0.14em 0rem rgba(252, 43, 30, 0.29);
  }

  .btn-tips {
    left: 47%;
    bottom: 70%;
    height: 0.44rem;
    line-height: 0.44rem;
    padding: 0 0.18rem;
    background: #f44138;
    border-radius: 0.22rem 0.22rem 0.22rem 0;
    font-size: 0.22rem;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #ffffff;
  }

  .protocols {
    padding: 0 0.3rem;
    font-size: 0.24rem;

    ::v-deep .van-checkbox__icon {
      margin-top: 0.05rem;
    }

    ::v-deep .van-checkbox__label {
      color: #c7cacd;
    }
  }

  .protocols-title {
    color: #ff5713;
    font-size: 0.24rem;
  }

  .tel-con {
    margin-top: 0.36rem;
    font-size: 0.22rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: normal;
    color: #868e9e;

    > a {
      color: #3563fa;
    }
  }

  .bottom {
    margin: 0.24rem auto;
    font-family: PingFangSC, PingFangSC-Regular;
    text-align: center;
    white-space: pre-line;
    font-weight: 300;
    font-size: 0.22rem;
    color: #999eac;
    line-height: 0.33rem;
  }

  .show-con {
    padding: 0 0.4rem;
    height: 100%;
    overflow: hidden;
  }

  .pup-title {
    margin: 0.4rem 0 0.24rem;
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #868e9e;
    text-align: justify;
  }

  .pup-protocol {
    height: calc(100% - 2.98rem);
    overflow: auto;

    > div {
      height: 45%;
      background: #ebf3fd;
      border-radius: 0.12rem;
      padding: 0.26rem;
      margin-bottom: 0.2rem;
      overflow: hidden;
      transition: height 1s linear;
    }

    > div.expand-height {
      height: auto;
    }

    h4 {
      margin-bottom: 0.2rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #3c3e41;
    }

    .islink {
      padding: 0.05rem;
      right: 0;
      bottom: 0;
      width: 1.7rem;
      box-shadow: 0 0.02rem 0.2rem 0 rgba(0, 0, 0, 0.3);
    }
  }

  .go-on {
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #ffffff;
    box-shadow: 0px -0.04rem 0.2rem 0 rgba(0, 0, 0, 0.13);
    padding: 0.16rem 0.4rem 0.48rem;
    font-size: 0.32rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;

    > p {
      line-height: 0.96rem;
      background: #3563fa;
      border-radius: 0.48rem;
    }
  }

  .show-protocol-con {
    height: 100%;
    padding: 0.4rem 0.4rem 0;

    > h4 {
      margin-bottom: 0.2rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #3c3e41;
    }
  }

  .show-protocol-info {
    height: calc(100% - 1.45rem);
    overflow: auto;
  }

  .show-protocol-btn {
    left: 0;
    right: 0;
    border-top: 0.02rem solid #e3e3e3;
    font-size: 0.3rem;
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0 -0.4rem;
    font-family: PingFangSC, PingFangSC-Regular;
  }

  .picker-title {
    font-size: 0.32rem;

    p.pa {
      left: 0;
      top: 0.88rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #f44138;
      z-index: 2;
      padding: 0 0.25rem;
      text-align: left;
      background: #fff;
    }
  }
}
</style>
